import type { RefObject } from 'react';
import { useBoxSelect } from './useBoxSelect';
import { useDoubleClickZoom } from './useDoubleClickZoom';
import { useDragPan } from './useDragPan';
import { useWheelZoom } from './useWheelZoom';

/** All pane gestures of the canvas: drag to pan, Shift+drag to box select, wheel/pinch and double-click to zoom. */
export const usePanZoom = (rendererRef: RefObject<HTMLElement>): void => {
  useDragPan(rendererRef);
  useBoxSelect(rendererRef);
  useWheelZoom(rendererRef);
  useDoubleClickZoom(rendererRef);
};
